export * from './AvatarSetting';
export { ThingsAvatarSettings as default } from './AvatarSetting';
